import BaseAPI from './BaseAPI';

// The schedule — shifts that were planned, as opposed to worked. Under
// /schedule. `shifts` (ShiftsAPI) is the clock; this is the plan.
class ScheduleAPI extends BaseAPI {
  constructor() { super('schedule'); }

  // GET /schedule/me?start=&end= → everything the shifts page needs for a
  // range in one call: the plan, the clock, time off, pending requests,
  // coverage and per-day totals. One call so the panels cannot disagree.
  mine(start, end, idStaff) {
    const q = new URLSearchParams({ start, end });
    if (idStaff) q.set('idStaff', idStaff);
    return this.get(`/me?${q.toString()}`);
  }

  // GET /schedule/upcoming — the next posted shifts, whatever is on screen.
  upcoming(limit = 4) { return this.get(`/upcoming?limit=${limit}`); }

  list(params = {}) {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v) q.set(k, v); });
    return this.get(`/?${q.toString()}`);
  }

  // Admin only.
  create(body) { return this.post('/', { body }); }
  move(idSchedule, body) { return this.put(`/${idSchedule}`, { body }); }
  remove(idSchedule) { return this.delete(`/${idSchedule}`); }
  postWeek(weekStart, posted = true) {
    return this.post('/post-week', { body: { weekStart, posted } });
  }

  // POST /schedule/apply — one shift onto many cells at once. Each cell
  // replaces whatever was planned for that person that day.
  apply(cells) { return this.post('/apply', { body: { cells } }); }

  // POST /schedule/remove { idSchedules } → { removed }
  removeMany(idSchedules) { return this.post('/remove', { body: { idSchedules } }); }

  // POST /schedule/copy-week { from, to } → { copied, skipped }
  copyWeek(from, to) { return this.post('/copy-week', { body: { from, to } }); }
}

export const ScheduleService = new ScheduleAPI();
export default ScheduleAPI;
